class CostcoRoadshow extends HTMLElement {
  constructor() {
    super();
    this.dataSource = this.querySelector("[data-table]");
    this.tableContainer = this.querySelector(".costco-table");
    this.tableMobileContainer = this.querySelector(".costco-table-mobile");
    this.dataTranslationsElement = this.querySelector("[data-translations]");
    this.translations = [];
    this.jsonData = "";
    this.filteredData = "";
    this.monthsArr = [];
    this.minDesktopViewport = 768;
    this.currentCountryFiltered = "";
    this.costcoFilterHead = this.querySelector(".costco-filter__head");

    this.trTemplate = `<tr>
      <td>{whse}</td>
      <td>{data_range}</td>
      <td>{location}</td>
    </tr>`;

    this.tableTemplate = `<table>
      <thead>
        <tr class="costco-table-header-row">
          <th>{costco_roadshow.whse}</th>
          <th>{costco_roadshow.data_range}</th>
          <th>{costco_roadshow.location}</th>
        </tr>
      </thead>
      <tbody>{table_content}</tbody>
    </table>`;

    this.slideTemplate = `<div class="swiper-slide-content">
      <table>
        <tbody>
          <tr>
            <td class="line-title">{costco_roadshow.whse}</td>
            <td class="line-content">{whse}</td>
          </tr>
          <tr>
            <td class="line-title">{costco_roadshow.data_range}</td>
            <td class="line-content">{data_range}</td>
          </tr>
          <tr>
            <td class="line-title">{costco_roadshow.location}</td>
            <td class="line-content">{location}</td>
          </tr>
        </tbody>
      </table>
    </div>`;

    this.sliderTemplate = `<div class="swiper-container">
      <div class="swiper-wrapper">{table_content}</div>
    </div>`;

    this.filterCountryCell = `<div class="costco-filter__country-cell">{cell_content}</div>`;
  }

  connectedCallback() {
    if (this.dataTranslationsElement) {
      this.translations = JSON.parse(
        this.dataTranslationsElement.textContent ||
          this.dataTranslationsElement.innerText
      );

      this.tableTemplate = this.tableTemplate
        .replace("{costco_roadshow.whse}", this.translations.whse)
        .replace("{costco_roadshow.data_range}", this.translations.data_range)
        .replace("{costco_roadshow.location}", this.translations.location);

      this.slideTemplate = this.slideTemplate
        .replace("{costco_roadshow.whse}", this.translations.whse)
        .replace("{costco_roadshow.data_range}", this.translations.data_range)
        .replace("{costco_roadshow.location}", this.translations.location);
    }
    if (this.dataSource && this.tableContainer) {
      this.monthsArr = this.translations.months.split(", ");
      this.jsonData = JSON.parse(
        this.dataSource.textContent || this.dataSource.innerText
      );
      this.displayResults(this.jsonData);
      this.generateFilterDropDown(this.jsonData);
    }

    this.initSlider();
  }

  generateFilterDropDown(jsonData) {
    const uniqueCountries = [
      ...new Set(jsonData.map((location) => location.state)),
    ].sort();
    const filterDropdown = this.querySelector(
      ".costco-filter__dropdown-content"
    );

    if (filterDropdown) {
      let resultHtmlString = "";

      uniqueCountries.forEach((country) => {
        resultHtmlString += this.filterCountryCell.replace(
          "{cell_content}",
          country
        );
      });

      const tempContainer = document.createElement("div");
      filterDropdown.innerHTML = resultHtmlString;
      /*       const newElement = tempContainer.firstChild;
      filterDropdown.appendChild(newElement); */
      const countryButtons = filterDropdown.querySelectorAll(
        ".costco-filter__country-cell"
      );
      countryButtons.forEach((countryButton) => {
        countryButton.addEventListener("click", (event) => {
          this.filterLocations(event.currentTarget.textContent);
        });
      });

      if (this.costcoFilterHead)
        this.costcoFilterHead.addEventListener("click", (event) => {
          event.currentTarget.parentNode.classList.toggle("opened");
        });
    }
  }

  filterLocations(country) {
    this.tableContainer.innerHTML = "";
    this.currentCountryFiltered =
      this.currentCountryFiltered == country ? "" : country;
    this.displayResults(
      this.currentCountryFiltered == ""
        ? this.jsonData
        : this.jsonData.filter((location) => location.state == country)
    );
    if (this.costcoFilterHead)
      this.costcoFilterHead.parentNode.classList.toggle("opened");
  }

  displayResults(dataArr) {
    if (dataArr.length > 0) {
      let resultHtmlString = "";
      let resultHtmlStringMobile = "";
      dataArr.forEach((dataItem) => {
        const date1Split = dataItem.start_date.split("/");
        const date2Split = dataItem.end_date.split("/");
        const month1 = this.monthsArr[date1Split[0] - 1];
        const day1 = date1Split[1];
        const month2 = this.monthsArr[date2Split[0] - 1];
        const day2 = date2Split[1];
        const year = date2Split[2];
        const address = dataItem.address1;
        const title = dataItem.title;
        const zip = dataItem.zipcode;
        const dataRange =
          month1 + " " + day1 + " - " + month2 + " " + day2 + "," + year;
        const location = address + ", " + title + " " + zip;
        resultHtmlString += this.trTemplate
          .replace("{whse}", dataItem.warehouse_id)
          .replace("{data_range}", dataRange)
          .replace("{location}", location)
          .replace(/\n\s*/g, "")
          .replace(/\s{2,}/g, " ")
          .trim();

        resultHtmlStringMobile += this.slideTemplate
          .replace("{whse}", dataItem.warehouse_id)
          .replace("{data_range}", dataRange)
          .replace("{location}", location)
          .replace(/\n\s*/g, "")
          .replace(/\s{2,}/g, " ")
          .trim();
      });

      const resultContent = this.tableTemplate.replace(
        "{table_content}",
        resultHtmlString
      );

      const tempContainer = document.createElement("div");
      tempContainer.innerHTML = resultContent;
      const newElement = tempContainer.firstChild;
      this.tableContainer.appendChild(newElement);

      const tempContainerMobile = document.createElement("div");
      tempContainerMobile.innerHTML = resultHtmlStringMobile;
      const children = Array.from(tempContainerMobile.children);

      this.tableMobileContainer.innerHTML = "";

      for (let i = 0; i < children.length; i += 3) {
        const groupDiv = document.createElement("div");
        groupDiv.classList.add("swiper-slide"); // Optional: add a class for styling

        // Append up to 3 children to the new div
        for (let j = i; j < i + 3 && j < children.length; j++) {
          groupDiv.appendChild(children[j].cloneNode(true));
        }

        // Append the grouped div to the target container
        this.tableMobileContainer.appendChild(groupDiv);
      }

      this.initSlider();
    }
  }

  initSlider() {
    if (this.swiper) this.swiper.update();
    else
      this.swiper = new Swiper(".swiper-container", {
        loop: true,
        allowTouchMove: true, // Allow drag on desktop
        direction: "horizontal", // ensure it's horizontal
        slidesPerView: 1,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
        navigation: {
          prevEl: ".costco-slider-controls-prev",
          nextEl: ".costco-slider-controls-next",
        },
      });
    const navPrev = document.querySelector(".costco-slider-controls-prev");
    const navNext = document.querySelector(".costco-slider-controls-next");
    const slideCount = this.swiper.slides.length;

    if (slideCount < 2) {
      navNext.style.display = "none";
      navPrev.style.display = "none";
    } else {
      navNext.style.display = "";
      navPrev.style.display = "";
    }
  }
}

customElements.define("costco-roadshow", CostcoRoadshow);

document.addEventListener("DOMContentLoaded", function () {
  let swiperInstance;

  function initSwiper() {
    if (window.innerWidth <= 999) {
      if (!swiperInstance) {
        swiperInstance = new Swiper(
          ".product-list, .multi-column, .blog-posts-slider",
          {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            breakpoints: {
              480: {
                slidesPerView: 1,
                pagination: false,
                navigation: false,
              },
              999: {
                slidesPerView: 2,
                pagination: false,
                navigation: false,
              },
              1000: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
            },
          }
        );
      }
    } else {
      if (swiperInstance) {
        swiperInstance.destroy(true, true); // Destroy Swiper if switching to desktop
        swiperInstance = null;
        document
          .querySelector(".product-list, .multi-column")
          .classList.remove("swiper-container");
        document
          .querySelector(".product-list, .multi-column")
          .classList.remove("swiper-wrapper");
        document
          .querySelectorAll(".product-card, .multi-column__item")
          .forEach((card) => card.classList.remove("swiper-slide"));
      }
    }
  }

  // Run on initial load
  initSwiper();

  // Re-run on window resize or orientation change
  //window.addEventListener("resize", initSwiper);
  //window.addEventListener("orientationchange", initSwiper);

  function initSwiper2() {
    swiperInstance = new Swiper(".collection-list-sider", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next-collection-list",
        prevEl: ".swiper-button-prev-collection-list",
      },
      breakpoints: {
        480: {
          slidesPerView: 1,
        },
        999: {
          slidesPerView: 1,
        },
        1000: {
          slidesPerView: 1,
        },
      },
    });
  }
  initSwiper2();

  function initSwiper3() {
    swiperInstance = new Swiper(".customer-reviews-mobile", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        480: {
          slidesPerView: 1,
        },
        999: {
          slidesPerView: 2,
        },
        1000: {
          slidesPerView: 3,
        },
      },
    });
  }
  initSwiper3();

  function initSwiper4() {
    swiperInstance = new Swiper(
      ".testimonial-list-slider, .benefits-section-slider",
      {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          480: {
            slidesPerView: 1,
          },
          999: {
            slidesPerView: 2,
          },
          1000: {
            slidesPerView: 2,
          },
        },
      }
    );
  }
  initSwiper4();
});

// Use care popup
class useCarePop extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const closeButton = this.querySelector(
      ".use-care-pop--close-button button"
    );
    this.openURLButton = this.querySelector("[target-button-url]");
    const allButtons = document.querySelectorAll(".use-care--button button");
    allButtons.forEach((button) =>
      button.addEventListener("click", this.openPopup.bind(this))
    );
    closeButton.addEventListener("click", this.closePopup.bind(this));
  }

  openPopup(e) {
    this.setButtonURL(e.target.dataset.url);
    this.classList.add("use-care-pop__opened");
  }

  setButtonURL(newURL) {
    this.openURLButton.setAttribute("href", newURL);
  }

  closePopup() {
    this.classList.remove("use-care-pop__opened");
  }
}

if (!window.customElements.get("use-care-pop")) {
  window.customElements.define("use-care-pop", useCarePop);
}

// Backorder text

const dataVariantsBackorder = document.querySelector(
  "[data-variants-backorder]"
);

dataVariantsBackorder?.textContent || dataVariantsBackorder?.innerText;
const jsonBackorder =
  dataVariantsBackorder || dataVariantsBackorder
    ? JSON.parse(
        dataVariantsBackorder?.textContent || dataVariantsBackorder?.innerText
      )
    : null;

const productInfoBackorderInformation = document.querySelector(
  ".product-info__backorder-information"
);

const productInfoBackorderInformationDate = document.querySelector(
  ".product-info__backorder-information-date"
);

function _onBackorderVariantChanged(event) {
  if (!event.detail.variant || !productInfoBackorderInformation) {
    return;
  }
  const crtVariant = event.detail.variant;

  const productInfoBackorderDate = jsonBackorder.filter(
    (info) => info.variant_id == crtVariant.id
  )[0].back_order_date;
  const productInfoInventory = jsonBackorder.filter(
    (info) => info.variant_id == crtVariant.id
  )[0].variant_inventory;

  if (productInfoBackorderDate && productInfoBackorderInformationDate) {
    productInfoBackorderInformationDate.textContent = productInfoBackorderDate;
  }

  productInfoBackorderInformation[
    productInfoInventory <= 0 && productInfoBackorderDate != null
      ? "removeAttribute"
      : "setAttribute"
  ]("hidden", "");
}

const buyButtons = document.querySelector("buy-buttons");
const form = document.forms[buyButtons?.getAttribute("form")];
if (buyButtons && form) {
  form?.addEventListener(
    "variant:change",
    _onBackorderVariantChanged.bind(buyButtons)
  );
}

// Custom Announcemet Bar Swiper
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 1024 && window.Swiper) {
    new Swiper("#custom-announcement-swiper", {
      loop: true,
      autoHeight: true,
      navigation: {
        nextEl: ".custom-announcement-nav.next",
        prevEl: ".custom-announcement-nav.prev",
      },
      slidesPerView: 1,
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".custom-scroll-arrows").forEach((container) => {
    const sectionId = container.dataset.sliderControls;
    const carousel = document.getElementById("carousel-" + sectionId);

    if (!carousel) return;

    const scrollAmount = carousel.offsetWidth * 0.9;

    container.querySelector(".prev").addEventListener("click", () => {
      carousel.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });

    container.querySelector(".next").addEventListener("click", () => {
      carousel.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });
  });
});

// Custom styles for the form on the master landing page (Custom Image Form Section)
const container = document.querySelector(
  ".ciwf-image-form-grid .ciwf-image-form-right"
);

if (container) {
  const observer = new MutationObserver((mutations, obs) => {
    const formEmbedHost = container.querySelector("form-embed#app-embed");
    if (formEmbedHost && formEmbedHost.shadowRoot) {
      const shadowRoot = formEmbedHost.shadowRoot;

      const style = document.createElement("style");
      style.textContent = `
        form[data-testid="form"] input,
        form[data-testid="form"] textarea,
        form[data-testid="form"] select {
          border-radius: 30px !important;
          margin-bottom: 10px !important;
          border: 1px solid #ccc !important;
          transition: border-color 0.3s ease;
        }

        form[data-testid="form"] input:focus,
        form[data-testid="form"] textarea:focus,
        form[data-testid="form"] select:focus {
          outline: none !important;
        }

        form[data-testid="form"] button[type="submit"] {
          border-radius: 30px !important;
        }
      `;

      shadowRoot.appendChild(style);

      obs.disconnect();
    }
  });

  observer.observe(container, { childList: true, subtree: true });
}



// Plattar interation

let plattarContainer;
let plattarContentContainer;
let plattarViewContent;
let plattar360Content;
let plattarIDsDataElem;
let plattarIDsData;
let plattarEmbedQR;
let plattarEmbedViewer;
let optionsNamesLowerCase;

document.addEventListener("DOMContentLoaded", function () {
  plattarContainer = document.querySelector(".plattar-container");
  plattarContentContainer = document.querySelector(
    ".plattar-content-container"
  );
  plattarViewContent = document.querySelector(".plattar-view-content");
  plattar360Content = document.querySelector(".plattar-360-content");
  plattarIDsDataElem = document.querySelector("[data-plattar-ids]");
  plattarEmbedQR = document.querySelector("plattar-embed[init='qrcode']");
  plattarEmbedViewer = document.querySelector("plattar-embed[init='viewer']");

  if (document.querySelector("product-gallery") && plattarContentContainer) {
    const form =
      document.forms[
        document.querySelector("product-gallery").getAttribute("form")
      ];

    if (plattarIDsDataElem) {
      plattarIDsData = JSON.parse(
        plattarIDsDataElem.textContent || plattarIDsDataElem.innerText
      );
    }

    optionsNamesLowerCase = plattarContentContainer
      .getAttribute("data-options")
      .split(",");

    let plattarIDsArr = [];
    const variantPickerFieldsets = document.querySelectorAll(
      "variant-picker fieldset"
    );

    let packageIndex = 0;

    optionsNamesLowerCase.forEach(function (option, index) {
      const crtVariantOption = variantPickerFieldsets[index].querySelector(
        "input:checked + label span"
      ).textContent;
      let keyVal = "";
      let keyIndex = 0;

      if (option == "upholstery package") {
        packageIndex = plattarIDsData.findIndex(
          (obj) => obj.Variations[0]["Upholstery Package"] === crtVariantOption
        );
        return;
      }

      const optionGroup = plattarIDsData[packageIndex]["Variations"].filter(
        (optionKey) => {
          const keyIndexFound = Object.keys(optionKey).findIndex((key) => {
            if (key.toLowerCase() === option) keyVal = key;
            return key.toLowerCase() === option;
          });
          if (keyIndexFound != -1) keyIndex = keyIndexFound;
          return keyIndexFound != -1;
        }
      )[keyIndex][keyVal];

      Object.entries(optionGroup).forEach(([key, value]) => {
        if (crtVariantOption.toLowerCase() == key.toLowerCase())
          plattarIDsArr.push(value);
      });
    });

    let intv = setInterval(() => {
      if (!plattarEmbedViewer.viewer) {
        return;
      }
      clearInterval(intv);

      plattarEmbedViewer.viewer.context.setLoading = function (params) {
        if (params.loading == false) {
          const plattarSceneID = plattarIDsData[packageIndex]["Scene ID"];
          plattarEmbedQR.setAttribute("scene-id", plattarSceneID);
          plattarEmbedViewer.setAttribute("scene-id", plattarSceneID);

          const plattarIDsString = plattarIDsArr.join(",");
          plattarEmbedQR.setAttribute("variation-id", plattarIDsString);
          plattarEmbedViewer.setAttribute("variation-id", plattarIDsString);
        }
      };
    }, 100);

    form?.addEventListener("variant:change", function variantChange(data) {
      if (!data.detail.variant) return;
      packageIndex = 0;

      plattarIDsArr = [];

      optionsNamesLowerCase.forEach(function (option, index) {
        const crtVariantOption = data.detail.variant["option" + (index + 1)];
        if (option == "upholstery package") {
          packageIndex = plattarIDsData.findIndex(
            (obj) =>
              obj.Variations[0]["Upholstery Package"] === crtVariantOption
          );

          return;
        }

        let keyVal = "";
        let keyIndex = 0;
        const optionGroup = plattarIDsData[packageIndex]["Variations"].filter(
          (optionKey) => {
            const keyIndexFound = Object.keys(optionKey).findIndex((key) => {
              if (key.toLowerCase() === option) keyVal = key;

              return key.toLowerCase() === option;
            });
            if (keyIndexFound != -1) keyIndex = keyIndexFound;
            return keyIndexFound != -1;
          }
        )[keyIndex][keyVal];

        Object.entries(optionGroup).forEach(([key, value]) => {
          if (crtVariantOption.toLowerCase() == key.toLowerCase())
            plattarIDsArr.push(value);
        });
      });

      const plattarSceneID = plattarIDsData[packageIndex]["Scene ID"];
      plattarEmbedQR.setAttribute("scene-id", plattarSceneID);
      plattarEmbedViewer.setAttribute("scene-id", plattarSceneID);

      const plattarIDsString = plattarIDsArr.join(",");
      plattarEmbedQR.setAttribute("variation-id", plattarIDsString);
      plattarEmbedViewer.setAttribute("variation-id", plattarIDsString);
    });
  }
});

window.plattarStartAR = () => {

  const showQrCode = ()=> {
    console.log('AR Unavailable');
    if (plattarContainer) plattarContainer.classList.add("active");
    if (plattarContentContainer) plattarContentContainer.classList.add("active");
    if (plattarViewContent) plattarViewContent.classList.add("active");
    if (plattar360Content) plattar360Content.classList.remove("active");
  }

  if (!PlattarARAdapter){
    return console.error("PlattarARAdapter class not found. Please make sure the Plattar SDK is loaded on the page.");
  }
  
  if (PlattarARAdapter.Util.canAugment()) {
    console.log('Supports AR');

    plattarEmbedViewer.startAR()
    .catch(function(err) {
      console.error('Error starting AR:', err);
      showQrCode();
    });
  }
  else {
    showQrCode();
  }
  
};

window.plattarStartViewer = () => {
  if (plattarContainer) plattarContainer.classList.add("active");
  if (plattarContentContainer) plattarContentContainer.classList.add("active");
  if (plattarViewContent) plattarViewContent.classList.remove("active");
  if (plattar360Content) plattar360Content.classList.add("active");
};

window.plattarClose = () => {
  if (plattarContainer) plattarContainer.classList.remove("active");
  if (plattarContentContainer)
    plattarContentContainer.classList.remove("active");
  if (plattarViewContent) plattarViewContent.classList.remove("active");
  if (plattar360Content) plattar360Content.classList.remove("active");
};

// End Plattar interation